import * as React from 'react';
import warning from 'warning';
import { ManagerContext } from './Manager';
import { unwrapArray } from './utils';

export default function Reference(_ref) {
  var children = _ref.children;

  return React.createElement(
    ManagerContext.Consumer,
    null,
    function (_ref2) {
      var getReferenceRef = _ref2.getReferenceRef;

      warning(getReferenceRef, '`Reference` should not be used outside of a `Manager` component.');
      return unwrapArray(children)({ ref: getReferenceRef });
    }
  );
}